if (!customElements.get('instagram-feed-zoom')) {
  customElements.define(
    'instagram-feed-zoom',
    class InstagramFeedZoom extends HTMLElement {
      constructor() {
        super();
        this.zoomOpen = false;
        this.currentIndex = 0;
        this.images = [];
        this.observer = null;
      }

      connectedCallback() {
        this.feedBox = document.getElementById('instagram-feed-box');
        this.storiesBox = document.getElementById('instagram-stories-box');
        this.zoomModal = this.querySelector('.instagram-feed-zoom__modal');
        if (!this.zoomModal) return;

        this.track = this.zoomModal.querySelector('.instagram-feed-zoom__track');
        this.counterCurrent = this.zoomModal.querySelector('.instagram-feed-zoom__counter-current');
        this.counterTotal = this.zoomModal.querySelector('.instagram-feed-zoom__counter-total');
        this.counter = this.zoomModal.querySelector('.instagram-feed-zoom__counter');

        this.bindControls();
        this.bindFeedClicks();
        this.observeFeed();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
      }

      bindControls() {
        const closeButton = this.zoomModal.querySelector('.instagram-feed-zoom__close');
        if (closeButton) closeButton.addEventListener('click', () => this.closeZoom());

        const prevButton = this.zoomModal.querySelector('.instagram-feed-zoom__nav--prev');
        const nextButton = this.zoomModal.querySelector('.instagram-feed-zoom__nav--next');
        if (prevButton) prevButton.addEventListener('click', () => this.moveZoom(-1));
        if (nextButton) nextButton.addEventListener('click', () => this.moveZoom(1));

        this.zoomModal.addEventListener('click', (event) => {
          if (
            event.target === this.zoomModal ||
            event.target.classList.contains('instagram-feed-zoom__viewport') ||
            event.target.classList.contains('instagram-feed-zoom__slide')
          ) {
            this.closeZoom();
          }
        });

        this.onKeydown = (event) => {
          if (!this.zoomOpen) return;
          if (event.key === 'Escape') this.closeZoom();
          else if (event.key === 'ArrowLeft') this.moveZoom(-1);
          else if (event.key === 'ArrowRight') this.moveZoom(1);
        };
        document.addEventListener('keydown', this.onKeydown);
      }

      bindFeedClicks() {
        const containers = [this.feedBox, this.storiesBox].filter(Boolean);
        containers.forEach((container) => {
          container.addEventListener('click', (event) => {
            const image = event.target.closest('img');
            if (!image || !container.contains(image)) return;

            event.preventDefault();
            event.stopPropagation();

            this.collectImages();
            const index = this.images.findIndex((src) => src === this.normalizeSrc(image));
            this.openZoom(index >= 0 ? index : 0);
          }, true);
        });
      }

      observeFeed() {
        const containers = [this.feedBox, this.storiesBox].filter(Boolean);
        if (!containers.length) return;

        this.observer = new MutationObserver(() => {
          this.markZoomableImages();
        });

        containers.forEach((container) => {
          this.observer.observe(container, { childList: true, subtree: true });
        });

        this.markZoomableImages();
      }

      markZoomableImages() {
        const containers = [this.feedBox, this.storiesBox].filter(Boolean);
        containers.forEach((container) => {
          container.querySelectorAll('img').forEach((img) => {
            img.classList.add('instagram-feed-zoomable');
            img.style.cursor = 'zoom-in';
          });
        });
      }

      normalizeSrc(image) {
        return image.currentSrc || image.src || '';
      }

      collectImages() {
        const containers = [this.feedBox, this.storiesBox].filter(Boolean);
        const seen = new Set();
        this.images = [];

        containers.forEach((container) => {
          container.querySelectorAll('img').forEach((img) => {
            const src = this.normalizeSrc(img);
            if (!src || seen.has(src)) return;
            seen.add(src);
            this.images.push(src);
          });
        });
      }

      openZoom(index) {
        if (!this.images.length) return;

        this.currentIndex = index;
        this.renderSlides();
        this.updateZoom();
        this.zoomModal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        this.zoomOpen = true;

        const closeButton = this.zoomModal.querySelector('.instagram-feed-zoom__close');
        if (closeButton) closeButton.focus();
      }

      closeZoom() {
        this.zoomModal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        this.zoomOpen = false;
      }

      moveZoom(direction) {
        const total = this.images.length;
        if (total === 0) return;
        this.currentIndex = (this.currentIndex + direction + total) % total;
        this.updateZoom();
      }

      renderSlides() {
        if (!this.track) return;
        this.track.innerHTML = this.images
          .map(
            (src) =>
              `<div class="instagram-feed-zoom__slide"><img class="instagram-feed-zoom__image" src="${src}" alt=""></div>`
          )
          .join('');

        if (this.counter) {
          this.counter.hidden = this.images.length <= 1;
        }
        if (this.counterTotal) {
          this.counterTotal.textContent = String(this.images.length);
        }

        const prevButton = this.zoomModal.querySelector('.instagram-feed-zoom__nav--prev');
        const nextButton = this.zoomModal.querySelector('.instagram-feed-zoom__nav--next');
        if (prevButton) prevButton.hidden = this.images.length <= 1;
        if (nextButton) nextButton.hidden = this.images.length <= 1;
      }

      updateZoom() {
        const slides = this.track ? Array.from(this.track.children) : [];
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.currentIndex));
        if (this.track) this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        if (this.counterCurrent) this.counterCurrent.textContent = String(this.currentIndex + 1);
      }
    }
  );
}
